import React, {forwardRef, useImperativeHandle, useState} from 'react';
import styled  from 'styled-components';
// import Img1 from '../../active_135/imgs/bg3.png'
// import Img1  from './../images/bg2.png';
import Img1 from '../../images/modal3.png'
// import bridge from '@/config/JSbridge'
import { fetchCouponAccept } from "../../../../api/user-new"
const Comfirm = forwardRef((props,ref) => {
  const [visible, setVisible] = useState(false)
  function show() {
    setVisible(true);
  }
  useImperativeHandle(ref, () => ({
    show
  }));
  function close () {
   
    props.accept();
    setVisible(false);
    

  }
  
  function handleSubmit() {
    fetchCouponAccept(139)
    close();
    // localStorage.setItem(`active140_${userId}_isBuy`, JSON.stringify(true)); // 是否已经购买
  }
  // function liveApp() {
  //   bridge.callHandler('nativeEvent', {event: 'close', params: {
  //     isDelete: false
  //   }}, () => {})
  // }
  return (
    <ComfirmContainer className={visible?'':'hide'} onClick={()=>close()}>
       
      <div className='bg1' onClick={()=> handleSubmit()} >
      <div className='close' onClick={(e) => {
        e.stopPropagation()
        close()
      }}>
          <img src={require('../../images/close.png')} alt='' />
        </div>
        <div className='content' onClick={(e)=>{e.stopPropagation()}}>
          
        </div>
        
        
      </div>
     
    </ComfirmContainer>
  )
})

export default Comfirm;

const ComfirmContainer = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0, 0.82);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  &.hide {
    display: none;
  }
 .title {
    font-weight: bold;
    font-size: 30px;
    color: #000000;
    line-height: 45px;
    .money {
      font-size: 44px;
      color: #ED3535;
    }
  }
  // .close {
  //   width: 40px;
  //   height: 40px;
  //   background-color: red;
  //   position:absolute;
  //   top: 0;
  //   right: 0;
  //   z-index: 9;
  // }
  .bg1 {
    width: 84vw;
    height: 109vw;
    margin: auto;
    background-image: url(${Img1});
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
    .content {
      box-sizing: border-box;
      padding: 120px 23px 0;
    }
  }
  .tips {
    margin-top:10px;
    font-weight: 400;
    font-size: 18px;
    color: #000000;
    line-height: 21px;
    width: 275px;
    box-sizing: border-box;
    .name {
      font-weight: bold;
    }
    .money {
      color: #FD3032;
    }
    p {
      line-height: 1.1;
    }
  }
  .content {
     width: 100%;
  }
  
  .footer {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-around;
    position: absolute;
    left: 0;
    bottom: 2vw;
    z-index:1;
   >div {

    margin-bottom: 11px;
   }
    img {
      height: 40px;
      width: 100%;
    }
  }
  .close {
    position: absolute;
    margin: auto;
    text-align: center;
    width: 40px;
    height: 40px;
    right:0;
    top: 0px;
    background: #898989;
    z-index:9;
    text-align: center;
    border-radius:20px;
    line-height: 40px;
    transform:translateY(-100%) translatex(50%);
  
    color: #898989;
    text-decoration: underline;
    img {
      vertical-align: middle;
    }
  }
`



// WEBPACK FOOTER //
// ./src/views/activity_139/components/firstMoadl/index.js